<template>
  <div class="header">
    <div class="title">{{joined_exam?.examType?.examTypeName}}{{joined_exam?.examSubject}}考试</div>
    <div class="timer">
      <!-- <el-button type="primary" text bg @click="fetchExamineeInfo">
        刷新
      </el-button> -->
      考试倒计时: <span class="time">{{ getCountdown() }}(开考{{ joined_exam?.examSubject=='理论知识'?'45':'60' }}分钟内不能交卷)</span>
    </div>
    <el-button type="danger" class="logout" @click="handleLogout">
      <el-icon><SwitchButton /></el-icon>
      退出登录
    </el-button>
  </div>
</template>

<script>
/* eslint-disable */
import { ElButton, ElMessage, ElIcon } from 'element-plus';
import { SwitchButton } from '@element-plus/icons-vue';
import api from '@/utils/api';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ExamHeader',
  data() {
    return {
      currentTime: new Date(),
      userInfo: {},
      startTime: '',
      endTime: '',
      intervalId: null
    };
  },
  components: {
    ElButton,
    ElMessage,
    ElIcon,
    SwitchButton,
  },
  mounted() {
    // 初始化 joined_exam
    this.loadJoinedExam();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.updateTimes(this.joined_exam);
    this.intervalId = setInterval(this.updateCurrentTime, 1000);
  },
  watch: {
    // 监听 joined_exam 的变化
    joined_exam: {
      handler(newVal) {
        if (newVal && newVal.examStartTime && newVal.examEndTime) {
          this.updateTimes(newVal);
        }
      },
      deep: true,
      immediate: true, // 立即执行一次
    },
  },
  computed: {
    ...mapGetters(['getJoinedExam']),
    joined_exam() {
      return this.getJoinedExam;
    }
  },
  methods: {
    ...mapActions(['updateJoinedExam']),
    handleLogout() {
      localStorage.clear();
      sessionStorage.clear();
      ElMessage.success('退出登录成功');
      this.$router.push('/student-login');
    },
    updateCurrentTime() {
      this.currentTime = new Date();
      // 如果需要，您可以在这里执行其他操作
    },
    loadJoinedExam() {
      const exam = this.joined_exam;
      if (exam) {
        this.updateTimes(exam);
      }
    },
    updateTimes(exam) {
      const examAddTime = exam.examAddTime || 0; // 默认加时时间为0
      const examineeAddTime = exam.examineeAddTime || 0; // 默认加时时间为0
      this.startTime = new Date(exam.examStartTime);
      this.endTime = new Date(exam.examEndTime);
      
      // 根据 addTime 更新结束时间
      this.endTime.setMinutes(this.endTime.getMinutes() + examAddTime + examineeAddTime);
    },
    getCountdown() {
      const start = new Date(this.startTime).getTime();
      const end = new Date(this.endTime).getTime();
      const current = this.currentTime.getTime();

      if (isNaN(start) || isNaN(end)) {
        return '无效的考试时间';
      }

      if (current >= start && current <= end) {
        // 当前时间早于开始时间，显示倒计时到开始时间
        const remaining = end - current;
        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remaining / (1000 * 60)) % 60);
        const seconds = Math.floor((remaining / 1000) % 60);
        return `${days}天${hours}小时${minutes}分钟${seconds}秒`;
      }
      return '不在考试时间';
    },
    fetchExamineeInfo() {
      const uid = this.userInfo ? this.userInfo.uid : null;
      api.getExamineeExams(uid).then(response => {
        console.log('获取考试信息成功:', response.data);
        const exams = response.data;
        const exam = exams.find(item => item.examid === this.joined_exam.examid);
        localStorage.setItem('examineeInfo', JSON.stringify(exams));
        this.updateJoinedExam(exam);
        ElMessage.success('刷新成功');
      }).catch(error => {
        console.error('获取考生信息失败:', error);
        ElMessage.error('刷新失败');
      });
    },
  },
  onUnmounted() {
    clearInterval(this.intervalId);
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #70a1f8;
  color: #fff;
  padding: 10px 20px;
  height: 5%;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.timer {
  font-size: 16px;
}

.logout {
  background-color: #ff4d4f;
}


</style>
